import {
  OrganizationRoleType,
  OrgUserInviteRole,
} from "../../../../autogen/bff-api";
import { useTranslation } from "react-i18next";
import { useNamesSourcingViewerAsMember } from "./useNamesSourcingViewerAsMember";
import { useRoles } from "./useRoles";

export const useRoleName = () => {
  const { t } = useTranslation();
  const roles = useRoles();
  const namesSourcingViewerAsMember = useNamesSourcingViewerAsMember();
  return (role: OrganizationRoleType | OrgUserInviteRole) =>
    namesSourcingViewerAsMember && role === OrganizationRoleType.SourcingViewer
      ? t("Member")
      : (roles.find((userRole) => userRole.value === role)?.label ?? "Unknown role");
};
